import 'react';
import EmptyConfirmDialog from '@/adjustment/adjust/support/EmptyConfirmDialog';

export const NO_DIRECTOR_CONFIRM_MESSAGE = 'No have any director, could you append at it?';
export const ISSUED_CAPITAL_CODE = 'BS-EQ-IC';

export type NoDirectorConfirmDialogProps = {
    open: boolean;
    onDismiss: () => void;
    onCloseWp: () => void;
    onRequestOpenCode?: (code: string) => void;
};

export default function NoDirectorConfirmDialog({
    open,
    onDismiss,
    onCloseWp,
    onRequestOpenCode,
}: NoDirectorConfirmDialogProps) {
    const handleClose = () => {
        onDismiss();
        onCloseWp();
    };

    return (
        <EmptyConfirmDialog
            open={open}
            message={NO_DIRECTOR_CONFIRM_MESSAGE}
            onConfirm={() => {
                handleClose();
                onRequestOpenCode?.(ISSUED_CAPITAL_CODE);
            }}
            onCancel={handleClose}
        />
    );
}
